// extracted by css-extract-rspack-plugin
export default {"CollapsedMoveParameterMenuInput":"ED8I1","MoveParameterMenuOptionIcon":"Kvhub","MoveParameterMenuOptionText":"l75G0","MoveParameterMenuOption":"Vs1Rn"};